import React from "react";

import { Button, Card, Col } from "react-bootstrap";

const ProjectCard = ({ title, desc, image, liveUrl, srcUrl }) => {
  return (
    <Col className="d-flex justify-content-center w-100 mb-5">
      <div className="project-card">
        <Card className="text-light text-center square border border-3 border-accent rounded-9 mt-5 g-2 w-100 h-100">
          <Card.Img variant="top" src={image} alt={title} />
          <Card.Body className="d-flex flex-column">
            <Card.Title>{title}</Card.Title>
            <Card.Text>{desc}</Card.Text>

            <div className="text-center mt-auto">
              {liveUrl && (
                <a href={liveUrl} target="_blank" rel="noreferrer noopener">
                  <Button variant="primary" className="m-2 align-self-end">
                    Live Demo
                  </Button>
                </a>
              )}

              <a href={srcUrl} target="_blank" rel="noreferrer noopener">
                <Button variant="primary" className="m-2">
                  Show me Code
                </Button>
              </a>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Col>
  );
};

export default ProjectCard;
